import { render, staticRenderFns } from "./AwardRoleSelect.vue?vue&type=template&id=45516fa5&scoped=true&"
import script from "./AwardRoleSelect.vue?vue&type=script&lang=js&"
export * from "./AwardRoleSelect.vue?vue&type=script&lang=js&"
import style0 from "./AwardRoleSelect.vue?vue&type=style&index=0&id=45516fa5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45516fa5",
  null
  
)

export default component.exports